export default {
	SET_SIGN_UP: 'SET_SIGN_UP',
	SET_METHOD: 'SET_METHOD'
}
